/**
 * Setup Two-Factor Required Page (Story 1.7 / 10-5-10)
 * Full-page 2FA setup when grace period has expired.
 */
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ShieldExclamationIcon } from "@heroicons/react/24/outline";
import { TwoFactorSetup } from "../organisms/TwoFactorSetup";
import { Button } from "../atoms/Button";
import { useAuthStore } from "../../store/authStore";

export function SetupTwoFactorRequired() {
  const navigate = useNavigate();
  const { logout, setGracePeriod } = useAuthStore();
  const [showSetup, setShowSetup] = useState(false);

  const handleSetupComplete = () => {
    setShowSetup(false);
    // Clear grace period and redirect to dashboard
    setGracePeriod(false, null);
    navigate("/dashboard", { replace: true });
  };

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900 px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-danger-100 dark:bg-danger-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldExclamationIcon className="w-10 h-10 text-danger-600 dark:text-danger-400" />
        </div>

        <h1 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100 mb-4">
          Two-Factor Authentication Required
        </h1>

        <p className="text-neutral-600 dark:text-neutral-400 mb-2">
          Your 7-day grace period has expired. To continue using GlobalClean,
          you must enable two-factor authentication on your account.
        </p>

        <p className="text-sm text-neutral-500 dark:text-neutral-500 mb-8">
          This helps protect your account and sensitive business data.
        </p>

        <div className="space-y-3">
          <Button
            variant="primary"
            size="lg"
            onClick={() => setShowSetup(true)}
            className="w-full"
          >
            Set Up 2FA Now
          </Button>

          <Link to="/settings/security">
            <Button variant="secondary" className="w-full">
              Open Security Settings
            </Button>
          </Link>

          <Button variant="ghost" onClick={handleLogout} className="w-full">
            Log out
          </Button>
        </div>

        {/* 2FA Setup Modal */}
        <TwoFactorSetup
          isOpen={showSetup}
          onClose={() => setShowSetup(false)}
          onComplete={handleSetupComplete}
        />
      </div>
    </div>
  );
}
